const initialPickerConfig = {}

switch (window.lang) {
    case 'ru': {
        initialPickerConfig.startDay = 1;
        initialPickerConfig.customDays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
        initialPickerConfig.customMonths = [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ];
        initialPickerConfig.customOverlayMonths = ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
        initialPickerConfig.overlayPlaceholder = 'Введите год';
    }
}

function pickerInit(picker, options = {}) {
    if (picker.classList.contains('datepicker-init')) return;

    datepicker(picker, {
        ...initialPickerConfig,
        ...options
    })

    picker.classList.add('datepicker-init');
}

function initDatePicker() {
    if (document.querySelector('.js-datepicker')) {
        const pickers = document.querySelectorAll('.js-datepicker');

        const event = new Event('pickerselect', {
            bubbles: true,
        })

        pickers.forEach(picker => {
            let maxDate = new Date();
            let minDate = null;

            if (picker.dataset.reverse) {
                minDate = new Date();
                maxDate = null;
            }

            pickerInit(picker, {
                formatter: (input, date, instance) => {
                    input.value = date.toLocaleDateString().replace('/', '.');
                    picker.dispatchEvent(event);
                    picker.dispatchEvent(new Event('input'));
                },
                minDate,
                maxDate,
            })
        })
    }

    if (document.querySelector('.js-datepicker-delivery')) {
        const pickers = document.querySelectorAll('.js-datepicker-delivery');

        pickers.forEach(picker => {
            const maxDate = picker.dataset.maxDate ? new Date(picker.dataset.maxDate) : new Date();
            const minDate = picker.dataset.minDate ? new Date(picker.dataset.minDate) : null;
            const dateSelected = picker.dataset.initial ? new Date(picker.dataset.initial) : new Date();

            pickerInit(picker, {
                formatter: (input, date, instance) => {
                    if (window.lang === 'ru') {
                        input.value = `${initialPickerConfig.customDays[date.getDay()]}, ${date.getDate()} ${initialPickerConfig.customMonths[date.getMonth()].toLowerCase().slice(0, 3)}.`;
                    } else if (window.lang === 'en') {
                        input.value = `${instance.days[date.getDay()]}, ${date.getDate()} ${instance.overlayMonths[date.getMonth()]}.`;
                    }

                    state.orderDeliveryDate = date.toLocaleDateString().replace('/', '.');
                    picker.dispatchEvent(new Event('input'));
                },
                maxDate,
                minDate,
                dateSelected,
            })
        })
    }
}
